'use client';

import { ImageBj } from '@components/common/ImageBj/ImageBj';
import loginBg from '@images/login/girl_register_company.png';

/**
 * @description Recruiter register background imaage
 */
export const RecruiterBackgroundImage = () => (
  <ImageBj
    src={loginBg}
    alt="Login Background"
    className="absolute left-0 bottom-0 hidden object-cover lg:block h-4/6 xl:h-5/6 -ml-[40%] xl:-ml-[250px]"
    priority
  />
);
